import {
  Component,
  OnInit,
  Input,
  AfterViewChecked,
  AfterViewInit
} from '@angular/core';
import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';
import { DataUrlPipe } from 'src/app/shared/pipes/pipes/data-url.pipe';
import { SafeStylePipe } from 'src/app/shared/pipes/pipes/safe-style.pipe';

@Component({
  selector: 'app-circle-image',
  templateUrl: './circle-image.component.html',
  styleUrls: ['./circle-image.component.scss'],
  providers: [DataUrlPipe, SafeStylePipe]
})
export class CircleImageComponent implements OnInit, AfterViewInit {
  @Input() photo?: IDataUrlParam = null;
  @Input() url?: string = null;
  @Input() width = 30;
  @Input() backgroundWhite = false

  @Input() fileData: string = null;

  private _text: string;

  @Input() set text(value: string) {
    this._text = value;
    this.getInitials();
  }

  get text(): string {
    return this._text;
  }

  public initials = '';

  constructor(
    private dataPipe: DataUrlPipe,
    private safeStylePipe: SafeStylePipe
  ) { }

  ngOnInit() {
    this.getInitials();
  }

  ngAfterViewInit() {
    this.getInitials();
  }

  private getInitials() {
    if (this.photo == null && this.text && this.text.length) {
      let strSplit = this.text.split(' ').map(i => i.charAt(0));
      strSplit = strSplit.filter(e => {
        return /[a-zA-Z]/.test(e);
      });

      this.initials = strSplit.join('');
    }
  }

  public getBackgroundImage() {
    if (this.photo) {
      return this.safeStylePipe.transform(
        'url(' + this.dataPipe.transform(this.photo) + ')'
      );
    } else if (this.url && this.url.length) {
      return this.safeStylePipe.transform('url(' + this.url + ')');
    }

    return '';
  }
}